import { BaseSortVisitor } from './baseSort.visitor';
import { SchemaUtil } from '../utils/schema.util';
import { RankPlainObject } from '../plainObjects/rank.plainObject';

export class RankVisitor extends BaseSortVisitor {
    private get _rankTransformation(): RankPlainObject {
        return this.transformation as RankPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitOutputDefinition(outputDefinitionContext: any): void {
        const schema = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
        this._rankTransformation.keyColumn = schema[0];
    }
}
